import { defineMessages } from 'react-intl';

/** The copy of "Send to all" (design profile-card c1–c6). */
export const sendAllMessages = defineMessages({
  open: { id: 'app.sml.promote.profile.sendAll.open', defaultMessage: 'Send to all' },
  title: { id: 'app.sml.promote.profile.sendAll.title', defaultMessage: 'Send to all' },
  subtitle: {
    id: 'app.sml.promote.profile.sendAll.subtitle',
    defaultMessage: 'Put your new look on every profile in one go.',
  },
  close: { id: 'app.sml.promote.profile.sendAll.close', defaultMessage: 'Close' },
  cancel: { id: 'app.sml.promote.profile.sendAll.cancel', defaultMessage: 'Cancel' },
  done: { id: 'app.sml.promote.profile.sendAll.done', defaultMessage: 'Done' },
  weSend: { id: 'app.sml.promote.profile.sendAll.weSend', defaultMessage: 'We send it for you' },
  leadNoneConnected: {
    id: 'app.sml.promote.profile.sendAll.lead.noneConnected',
    defaultMessage: 'Connect a service once. Then one click puts your images and bio on it.',
  },
  leadPick: {
    id: 'app.sml.promote.profile.sendAll.lead.pick',
    defaultMessage: 'Tick what goes where. Your current versions go.',
  },
  leadWorking: { id: 'app.sml.promote.profile.sendAll.lead.working', defaultMessage: 'About 30 seconds.' },
  leadAllLive: {
    id: 'app.sml.promote.profile.sendAll.lead.allLive',
    defaultMessage: 'Everything you ticked is live.',
  },
  leadSomeFailed: {
    id: 'app.sml.promote.profile.sendAll.lead.someFailed',
    defaultMessage: '{count, plural, one {# item failed} other {# items failed}}. The rest is live.',
  },
  banner: {
    id: 'app.sml.promote.profile.sendAll.banner',
    defaultMessage:
      'Sending to {count, plural, one {# service} other {# services}}. You can close this. We finish in the background.',
  },
  notConnected: { id: 'app.sml.promote.profile.sendAll.notConnected', defaultMessage: 'Not connected' },
  connected: { id: 'app.sml.promote.profile.sendAll.connected', defaultMessage: '{name} · connected' },
  notAvailableYet: { id: 'app.sml.promote.profile.sendAll.notAvailableYet', defaultMessage: 'Not available yet' },
  connect: { id: 'app.sml.promote.profile.sendAll.connect', defaultMessage: 'Connect' },
  reconnect: { id: 'app.sml.promote.profile.sendAll.reconnect', defaultMessage: 'Sign in again' },
  retry: { id: 'app.sml.promote.profile.sendAll.retry', defaultMessage: 'Retry' },
  chipLive: { id: 'app.sml.promote.profile.sendAll.chip.live', defaultMessage: 'Live since {time}' },
  chipLiveNoTime: { id: 'app.sml.promote.profile.sendAll.chip.liveNoTime', defaultMessage: 'Live' },
  chipSending: { id: 'app.sml.promote.profile.sendAll.chip.sending', defaultMessage: 'Sending' },
  chipWaiting: { id: 'app.sml.promote.profile.sendAll.chip.waiting', defaultMessage: 'Waiting' },
  chipFailed: { id: 'app.sml.promote.profile.sendAll.chip.failed', defaultMessage: 'Failed' },
  chipReadOnly: { id: 'app.sml.promote.profile.sendAll.chip.readOnly', defaultMessage: 'Read-only' },
  chipComingSoon: { id: 'app.sml.promote.profile.sendAll.chip.comingSoon', defaultMessage: 'Coming soon' },
  noteYoutube: {
    id: 'app.sml.promote.profile.sendAll.note.youtube',
    defaultMessage: 'YouTube takes the profile picture from your Google account only. Change it there.',
  },
  noteFacebook: {
    id: 'app.sml.promote.profile.sendAll.note.facebook',
    defaultMessage: 'We wait for Meta to approve our access. Until then, set it by hand below.',
  },
  rights: {
    id: 'app.sml.promote.profile.sendAll.rights',
    defaultMessage:
      'By sending, you agree that you have all of the legal rights to these images, links and the bio, as the terms of each service describe.',
  },
  rightsOnce: { id: 'app.sml.promote.profile.sendAll.rightsOnce', defaultMessage: 'We ask once per artist.' },
  sync: { id: 'app.sml.promote.profile.sendAll.sync', defaultMessage: 'Keep my profiles in sync' },
  syncOff: {
    id: 'app.sml.promote.profile.sendAll.syncOff',
    defaultMessage: 'Off. When it is on, a new version goes on its own to the services where it is live.',
  },
  syncOn: {
    id: 'app.sml.promote.profile.sendAll.syncOn',
    defaultMessage: 'On. A new version of an image goes on its own to the services where it is live.',
  },
  syncNeedsRights: {
    id: 'app.sml.promote.profile.sendAll.syncNeedsRights',
    defaultMessage: 'Send once first. The switch needs the rights line.',
  },
  byHand: { id: 'app.sml.promote.profile.sendAll.byHand', defaultMessage: 'Set these by hand' },
  byHandNone: {
    id: 'app.sml.promote.profile.sendAll.byHandNone',
    defaultMessage: 'No way in for us here. Download the file, put it up, then mark it.',
  },
  byHandCount: {
    id: 'app.sml.promote.profile.sendAll.byHandCount',
    defaultMessage: '{set} of {total} marked set.',
  },
  openSettings: { id: 'app.sml.promote.profile.sendAll.openSettings', defaultMessage: 'Open the settings page' },
  setOn: { id: 'app.sml.promote.profile.sendAll.setOn', defaultMessage: 'Set {date}' },
  undoSet: { id: 'app.sml.promote.profile.sendAll.undoSet', defaultMessage: 'Undo' },
  handInstagram: {
    id: 'app.sml.promote.profile.sendAll.hand.instagram',
    defaultMessage: 'Artist photo 1500 x 1500 (shows round) · short bio, 150 characters',
  },
  handTiktok: {
    id: 'app.sml.promote.profile.sendAll.hand.tiktok',
    defaultMessage: 'Artist photo 1500 x 1500 · short bio, cut to 80 characters',
  },
  handThreads: { id: 'app.sml.promote.profile.sendAll.hand.threads', defaultMessage: 'Artist photo · short bio' },
  handSoundcloud: {
    id: 'app.sml.promote.profile.sendAll.hand.soundcloud',
    defaultMessage: 'Artist photo · long bio',
  },
  handApple: { id: 'app.sml.promote.profile.sendAll.hand.apple', defaultMessage: 'Artist photo 1500 x 1500' },
  handAmazon: { id: 'app.sml.promote.profile.sendAll.hand.amazon', defaultMessage: 'Artist photo · long bio' },
  handTidal: { id: 'app.sml.promote.profile.sendAll.hand.tidal', defaultMessage: 'Artist photo · long bio' },
  handBandcamp: { id: 'app.sml.promote.profile.sendAll.hand.bandcamp', defaultMessage: 'Artist photo · long bio' },
  handX: {
    id: 'app.sml.promote.profile.sendAll.hand.x',
    defaultMessage: 'Artist photo · short bio, 160 characters',
  },
  sendTo: {
    id: 'app.sml.promote.profile.sendAll.sendTo',
    defaultMessage: 'Send to {count, plural, one {# service} other {# services}}',
  },
  sendBusy: { id: 'app.sml.promote.profile.sendAll.sendBusy', defaultMessage: 'Sending…' },
  retryItems: {
    id: 'app.sml.promote.profile.sendAll.retryItems',
    defaultMessage: 'Retry {count, plural, one {# item} other {# items}}',
  },
  metaNoService: { id: 'app.sml.promote.profile.sendAll.meta.noService', defaultMessage: 'Connect a service to send.' },
  metaReplaces: {
    id: 'app.sml.promote.profile.sendAll.meta.replaces',
    defaultMessage: 'It replaces what these profiles show now.',
  },
  metaRights: { id: 'app.sml.promote.profile.sendAll.meta.rights', defaultMessage: 'Tick the rights line to send.' },
  metaAllLive: { id: 'app.sml.promote.profile.sendAll.meta.allLive', defaultMessage: 'Nothing new to send.' },
  metaRetry: {
    id: 'app.sml.promote.profile.sendAll.meta.retry',
    defaultMessage: 'Retry sends only the failed items.',
  },
  metaWorking: {
    id: 'app.sml.promote.profile.sendAll.meta.working',
    defaultMessage: 'The Profile page shows the same status.',
  },
  connectFailed: {
    id: 'app.sml.promote.profile.sendAll.connectFailed',
    defaultMessage: 'The sign-in did not finish. Try again.',
  },
  startFailed: {
    id: 'app.sml.promote.profile.sendAll.startFailed',
    defaultMessage: 'We could not start the send. Try again.',
  },
});
